// Etiquetas de una semana (lunes a domingo). El mes sale del dia que toca, no del
// lunes: la semana del 28 de septiembre al 4 de octubre es «28 sep – 4 oct», no
// «28 – 4 de octubre» ni «28–4 sept».
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const mas6 = l => new Date(l.getFullYear(), l.getMonth(), l.getDate() + 6, 12);

// «5 – 11 oct 2026», «28 sep – 4 oct 2026», «29 dic 2026 – 4 ene 2027»
export function rangoSemana(lunes) {
  const d = mas6(lunes);
  const a = `${lunes.getDate()} ${MES[lunes.getMonth()]}`, b = `${d.getDate()} ${MES[d.getMonth()]}`;
  if (lunes.getFullYear() !== d.getFullYear()) return `${a} ${lunes.getFullYear()} – ${b} ${d.getFullYear()}`;
  if (lunes.getMonth() !== d.getMonth()) return `${a} – ${b} ${d.getFullYear()}`;
  return `${lunes.getDate()} – ${d.getDate()} ${MES[d.getMonth()]} ${d.getFullYear()}`;
}

// Etiqueta corta del selector: «5–11» y, si la semana cruza de mes, «28 sep–4 oct».
// `mesActual` (0-11) es el mes que muestra la tira: solo si la semana cae entera en
// otro mes se le pone el suyo («5–11 oct»).
export function rangoSemanaCorto(lunes, mesActual) {
  const d = mas6(lunes);
  if (lunes.getMonth() !== d.getMonth()) return `${lunes.getDate()} ${MES[lunes.getMonth()]}–${d.getDate()} ${MES[d.getMonth()]}`;
  const base = `${lunes.getDate()}–${d.getDate()}`;
  return lunes.getMonth() !== mesActual ? `${base} ${MES[d.getMonth()]}` : base;
}
